var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-scroll-container" },
      [_c("f9grid", { attrs: { columns: _vm.columns, data: _vm.priceData } })],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid-top" }, [
      _c("div", { staticClass: "grid-header" }, [_vm._v("BAG PRICES")]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-subheader" }, [
        _vm._v("Per Person / Per Direction")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-395db065", { render: render, staticRenderFns: staticRenderFns })
  }
}